import type {VehicleGeneralAdvertisingAttribute} from './VehicleGeneralAdvertisingAttribute';

export type VehicleGeneralAdvertisingSettings = {
  attributes: Array<VehicleGeneralAdvertisingAttribute>;
  updatedAt: string | null;
  updatedBy: string | null;
};
